import { Button, PageHeader } from 'components';
import { Form, Row, Col, Spin } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import NotificationFormForEdit from '../../../../../components/modules/notificationFormForEdit';
import useVacancies from '../useVacancies';
import ShowError from '../../../../../components/showError';

const Edit = ({ isNew, isView }) => {
  const { t } = useTranslation();
  const {
    filtersData,
    handleApprove,
    singleItem,
    updateInProcess,
    shoppingCenters,
    shops,
    inactiveShops,
    form,
    handleCreateOrUpdate,
    errors,
    user,
    approveErrors,
  } = useVacancies(false, !isNew);
  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  let title = isNew ? t('NUOVO ANNUNCIO') : t('MODIFICA ANNUNCIO');

  if (isView) {
    title = 'Visualizza';
  }

  const isAprroveOnly =
    singleItem.can_approve === true && singleItem.can_update === false;

  return (
    <div>
      <PageHeader title={title} />
      <Spin spinning={updateInProcess}>
        <div className={styles.content}>
          <ShowError errors={errors} type={'alert'} />
          <Form
            form={form}
            name='basic'
            wrapperCol={{
              span: 24,
            }}
            initialValues={{
              shopping_center_id: '',
              company_id: '',
              work_sector: '',
              title: '',
              description: '',
              expired_at: '',
              vacancy_application_type_id: '',
              user_created_at: '',
              vacancy_category_id: '',
              fields: [],
              published_at: '',
            }}
            layout={'vertical'}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <InfoSection
              user={user}
              filtersData={filtersData}
              shoppingCenters={shoppingCenters}
              shops={shops}
              inactiveShops={inactiveShops}
              form={form}
              isView={isView || isAprroveOnly}
            />
            {!isView && !isAprroveOnly && (
              <Row gutter={16}>
                <Col>
                  <Button
                    onClick={onClickSave}
                    width={'150px'}
                    big
                    icon={<CheckOutlined />}
                    loading={updateInProcess}
                  >
                    {t('Invia')}
                  </Button>
                </Col>
              </Row>
            )}
          </Form>
          {!isNew && !isView && (
            <NotificationFormForEdit
              approveErrors={approveErrors}
              loading={updateInProcess}
              handleOnFinish={handleApprove}
              showApprove={!!singleItem.can_approve}
              showReject={!!singleItem.can_reject}
              showToAdim={!!singleItem.can_to_admin}
              showRefuse={!!singleItem.can_refuse}
              paramKey={'type_approve'}
              backCount={1}
            />
          )}
        </div>
      </Spin>
    </div>
  );
};

export default Edit;
